module.exports = __webpack_public_path__ + "img/introduce-1.04d8c01d.png";